import { useEffect, useState } from "react";
import { StyledButtonMain } from "../common/Buttons";
import { useParams } from "react-router-dom";
import { axiosInstance } from "../../utils/networking";

const Unsubscribe = () => {
  // Get the firm id from the URL
  const { firmId } = useParams<{ firmId: string }>();
  const [firm, setFirm] = useState<any>({ email: "" });
  const [error, setError] = useState<string>("");
  const FAILURE_MESSAGE =
    "This unsubscribe link is invalid. Please reply to the email or contact support@thrive-drive.org and we will remove you.";
  useEffect(() => {
    // Broadcast footers have shipped with an unresolved "/unsubscribe/-firmId-"
    // link, so the param is not always a real id. Fail loudly instead of
    // querying with it.
    if (!firmId || !/^[0-9a-fA-F]{24}$/.test(firmId)) {
      setError(FAILURE_MESSAGE);
      return;
    }
    axiosInstance
      .get(`/firms/id?id=${firmId}`)
      .then((res) => {
        if (res.data && res.data.firm) {
          setFirm(res.data.firm);
        } else {
          setError(FAILURE_MESSAGE);
        }
      })
      .catch(() => {
        setError(FAILURE_MESSAGE);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firmId]);

  const unsubscribeUser = () => {
    setError("");
    axiosInstance
      .post(`/user/unsubscribe`, { firm_id: firm._id })
      .then((res) => {
        if (res.data) {
          window.location.reload();
        }
      })
      .catch((err) => {
        setError(err?.response?.data?.message || FAILURE_MESSAGE);
      });
  };

  if (error) {
    return <h1>{error}</h1>;
  }
  return firm["_id"] ? (
    firm["do_not_contact"] ? (
      <h1>Email {firm["Email"]} unsubscribed</h1>
    ) : (
      <div>
        <h1>Unsubscribe from all the communication from Oakland Thrive?</h1>
        <br></br>
        <p>Firm Email: {firm["Email"]}</p>
        <br></br>
        <StyledButtonMain variant="contained" onClick={unsubscribeUser}>
          Unsubscribe
        </StyledButtonMain>
      </div>
    )
  ) : (
    <h1>Loading...</h1>
  );
};

export default Unsubscribe;
